import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { rangeBetween, shuffle } from '~/utils'

import { RANGE_DATA, VARIABLES } from './PowerChoice.constants'

export interface EquationPartsModel {
  integer: number
  variable?: string
  exponent: number
}

export interface OptionModel {
  equation: EquationPartsModel[]
  isRight: boolean
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateEquationForPowerChoice(
  difficultyLevel: number,
  taskHistory: string[],
): [EquationPartsModel[], string, OptionModel[]] {
  const range = RANGE_DATA[difficultyLevel]
  const totalTerms = getRandomInt(range.minTerms, range.maxTerms)
  let equationParts: EquationPartsModel[] = []
  const variableIndexes: number[] = []
  // eslint-disable-next-line
  for (let i = 0; i < range.totalVariable; i++) {
    variableIndexes[i] = getRandomInt(0, VARIABLES.length - 1, variableIndexes)
  }
  let indexCounter = 0
  const exponents = [...shuffle(rangeBetween(range.minExponent, range.maxExponent + 1)).slice(0, 3), 0]
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms; i++) {
    equationParts[i] = {
      integer:
        i % 4 === 3
          ? getRandomInt(range.minInteger, range.maxInteger)
          : getRandomInt(range.minCoefficient, range.maxCoefficient),
      // operator: SIGNS[getRandomInt(0, SIGNS.length - 1)]),
      exponent: exponents[i % 4],
      variable: VARIABLES[variableIndexes[indexCounter % variableIndexes.length]],
    }
    indexCounter++
    if (Math.random() > 0.5) equationParts[i].integer = -1 * equationParts[i].integer
  }
  equationParts = shuffle(equationParts)
  let equationString = ''
  equationParts.forEach((item) => {
    equationString += `${item.integer} ${item.variable} ${item.exponent}`
  })
  if (taskHistory.includes(equationString)) return generateEquationForPowerChoice(difficultyLevel, taskHistory)
  return [equationParts, equationString, generateOptions(equationParts)]
}

/* eslint-disable */
/**
 * Generates options for the current question
 * @param equationParts parts of the actual equation
 * @returns list of options
 */
function generateOptions(equationParts: EquationPartsModel[]): OptionModel[] {
  const excludeIndex: number[] = []
  const options: OptionModel[] = []
  const _equationParts: EquationPartsModel[] = JSON.parse(JSON.stringify(equationParts))
  _equationParts.sort((a, b) => b.exponent - a.exponent)
  const simplifiedEquationPart: EquationPartsModel[] = [_equationParts[0]]
  //simplify the equation to get right option
  for (let i = 1; i < _equationParts.length; i++) {
    if (_equationParts[i].exponent === simplifiedEquationPart[simplifiedEquationPart.length - 1].exponent) {
      simplifiedEquationPart[simplifiedEquationPart.length - 1].integer += _equationParts[i].integer
    } else {
      simplifiedEquationPart[simplifiedEquationPart.length] = { ..._equationParts[i] }
    }
  }
  //generate three wrong option
  for (let i = 0; i < 3; i++) {
    const randomIndex = getRandomInt(0, simplifiedEquationPart.length - 1, [...excludeIndex])
    excludeIndex.push(randomIndex)
    const equation = JSON.parse(JSON.stringify(simplifiedEquationPart))
    equation[randomIndex].integer = getRandomInt(2, 20, [equation[randomIndex].integer])

    options.push({ equation, isRight: false })
  }
  //handle right option parts with 0 as coefficient
  const _answerOption: EquationPartsModel[] = []
  for (let i = 0; i < simplifiedEquationPart.length; i++) {
    if (simplifiedEquationPart[i].integer !== 0) _answerOption.push(simplifiedEquationPart[i])
  }
  options.push({ equation: _answerOption, isRight: true })
  return shuffle(options)
}
/* eslint-enable */
